import PerfEgresadosLayout from "../../layout/perfilEgresados/PerfilEgresadosLayout";

export default function perfilEhresados () {
    return (
        <>
         <PerfEgresadosLayout />
        </>
    )
}